/**
 * Compose-time notify channel helpers.
 * Mirrors keyon/lib/NotificationPreference.php: Email / SMS / Phone / All.
 * "All" is a real picker value (and may be sent as an override); the backend
 * expands it to email + SMS + phone the same way as communication_preference.
 */

export const NOTIFY_CHANNEL_OPTIONS = [
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS" },
  { value: "phone", label: "Phone" },
  { value: "all", label: "All" },
];

/** Default dropdown value from account_user.communication_preference. */
export function preferredNotifyChannel(communicationPreference) {
  const pref = String(communicationPreference || "")
    .toLowerCase()
    .trim();
  if (pref === "sms" || pref === "text") return "sms";
  if (pref === "phone" || pref === "call" || pref === "voice") return "phone";
  if (pref === "all") return "all";
  // email | empty | unknown → email
  return "email";
}

export function normalizeNotifyChannel(channel) {
  const ch = String(channel || "")
    .toLowerCase()
    .trim();
  if (ch === "sms" || ch === "email" || ch === "phone" || ch === "all") return ch;
  return "email";
}

/**
 * Build { uniqueId: channel } for recipients using saved overrides when present,
 * else preferred defaults from prefsById.
 */
export function buildNotifyChannelMap(recipients, overrides, prefsById) {
  const map = {};
  const list = Array.isArray(recipients) ? recipients : [];
  for (const r of list) {
    const uid = String(r.subaccountnumber || r.id || "").trim();
    if (!uid) continue;
    if (overrides && overrides[uid]) {
      map[uid] = normalizeNotifyChannel(overrides[uid]);
      continue;
    }
    const pref = prefsById && prefsById[uid] != null ? prefsById[uid] : "";
    map[uid] = preferredNotifyChannel(pref);
  }
  return map;
}
